import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";

export const firebaseConfig = {
  apiKey: "AIzaSyA69SULShrNETTxskwRaVcX1Una1w9QEZY",
  authDomain: "vrchat-matching-a373d.firebaseapp.com",
  databaseURL: "https://vrchat-matching-a373d-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "vrchat-matching-a373d",
  storageBucket: "vrchat-matching-a373d.firebasestorage.app",
  messagingSenderId: "1032688254960",
  appId: "1:1032688254960:web:aa72db645b56a35f0ba735"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const auth = getAuth(app);